module.exports = __webpack_public_path__ + "img/hl2.09006d31.png";